import { Component, OnInit } from "@angular/core";
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { TarefasSistemaService } from "./tarefas-sistema.service";


@Component({
    selector: 'app-tarefas-sistema',
    templateUrl: './tarefas-sistema.component.html',
    styleUrls: ['./tarefas-sistema.component.scss'],
    standalone: false
})
export class TarefasSistemaComponent implements OnInit {

  public data: Date;
  public dataSistema: Date;

  constructor(private sistemaService: TarefasSistemaService,
              private messageService: MessageChannelService,
              private alertService: BnAlertsService) {

  }

  ngOnInit(): void {
    this.obterData();
  }

  public obterData() {
    this.sistemaService.obterDataSistema().subscribe((dataAtual: any) => {
      this.dataSistema = moment(dataAtual.nowDateISO, 'YYYYMMDD').toDate();
    })
  }

  public alterarData() {
    if(this.data == null) {
      this.alertService.alertaErro('Erro', 'Selecione a nova data para realizar a alteração');
    } else {
    this.sistemaService.alterarDataSistema(moment(this.data).format('YYYY-MM-DD')).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Data Atualizada.'
        })
        this.dataSistema = this.data;
        this.data = null;
      })
    }
  }

  public retornarDataSistema() {
    this.sistemaService.obterDataSistema().subscribe((dataAtual: any) => {
      this.dataSistema = moment(dataAtual.nowDateISO, 'YYYYMMDD').toDate();
    })
  }


  public limpar() {
    this.data = null;
  }

}
